import { render, staticRenderFns } from "./addPayFeeConfigDiscount.vue?vue&type=template&id=485b27ce&scoped=true"
import script from "./addPayFeeConfigDiscount.vue?vue&type=script&lang=js"
export * from "./addPayFeeConfigDiscount.vue?vue&type=script&lang=js"
import style0 from "./addPayFeeConfigDiscount.vue?vue&type=style&index=0&id=485b27ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b27ce",
  null
  
)

export default component.exports